import React from 'react';
import { connect } from 'react-redux';
import md5 from 'md5';

import { Card, CardTitle, CardText, CardActions } from 'react-toolbox/lib/card';
import { setPassword } from '~/actions/user';

import Input from 'react-toolbox/lib/input';
import { Button } from 'react-toolbox/lib/button';
import Styles from './settings.scss';

class Index extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      newpassword: '',
      newpasswordagain: ''
    };
  }
  getGravatar(email) {
    return `https://www.gravatar.com/avatar/${md5(email)}?s=200`;
  }

  updatePassword() {
    const { password, newpassword, newpasswordagain } = this.state;
    if (newpassword === newpasswordagain) {
      // all ok lets change password
      setPassword(
        this.props.dispatch,
        this.context.apiClient,
        password,
        newpassword
      ).catch(err => {
        console.log(err);
        this.props.dispatch({
          type: 'SNACKBAR_SHOW_MSG',
          msg: JSON.stringify(err)
        });
      });
    } else {
      this.props.dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "New passwords don't match",
        snackType: 'warning'
      });
      this.setState({ newpasswordMatch: false });
    }
  }
  render() {
    const user = this.props.user && this.props.user.toJS();
    return (
      <div className={Styles.content}>
        <Card>
          <div className={Styles.orderTitle}>Settings</div>
          <CardTitle
            avatar={this.getGravatar(user.username)}
            title={user.name}
            subtitle={user.username}
          />
          <div className={Styles.orderTitle}>Update password</div>
          <CardText>
            <Input
              type="password"
              required
              placeholder="Current password"
              value={this.state.password}
              onChange={e => this.setState({ password: e })}
            />
            <Input
              type="password"
              required
              placeholder="New password"
              value={this.state.newpassword}
              onChange={e => this.setState({ newpassword: e })}
            />
            <Input
              type="password"
              required
              placeholder="New password again"
              value={this.state.newpasswordagain}
              onChange={e => this.setState({ newpasswordagain: e })}
            />
          </CardText>
          <CardActions>
            <Button label="Update" onClick={() => this.updatePassword()} />
          </CardActions>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.getIn(['user', 'self'], false)
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(Index);



// WEBPACK FOOTER //
// ./app/pages/Settings/index.js